package org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config

import com.varabyte.kobweb.browser.http.AbortController
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_cash_register.CreateCashRegisterModel
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_shop.CreateNewShopModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateCashRegisterRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewShopRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class CreateCashRegisterRepositoryImpl (
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): CreateCashRegisterRepository
{
    private var abortController: AbortController? = null

    override suspend fun createCashRegister(
        deviceType: String,
        name: String,
        shopId: String,
        hardwareId: String,
        settingsCopyId:String,
        deactivateAllContent:Boolean,
    ): CreateCashRegisterModel {
        abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                     mutation createCashRegister(
                     ${'$'}fields: CashRegisterReqInput!,
                       ${'$'}deviceType: cashRegisterType!,
                        ${'$'}settingsCopyId: ID,
                         ${'$'}hardwareId: ID,
                          ${'$'}deactivateAllContent: Boolean) {
                       cashAssist {
                         createCashRegister(
                           fields: ${'$'}fields
                           deviceType: ${'$'}deviceType
                           settingsCopyId: ${'$'}settingsCopyId
                           hardwareId: ${'$'}hardwareId
                           deactivateAllContent: ${'$'}deactivateAllContent
                         ) {
                           ${ApiUtils.Field.id}
                           
                           ${ApiUtils.Field.__typename}
                         }
                         ${ApiUtils.Field.__typename}
                       }
                     }

                  


                """.trimIndent()
            )


            putJsonObject("variables") {
                put("deviceType",deviceType)
                put("hardwareId",hardwareId)
                put("deactivateAllContent",deactivateAllContent)
                put("settingsCopyId",settingsCopyId)
                putJsonObject("fields"){
                    put("name",name)
                    put("shopId",shopId)
                }
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController!!,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }


    }

    override fun cancel() {
        abortController?.abort()
        abortController = null
    }

}


//fragment cashRegisterMain on CashRegister {
//    parameters {
//        ${ApiUtils.Field.phone}
//        ${ApiUtils.Field.street}
//        ${ApiUtils.Field.city}
//        ${ApiUtils.Field.postCode}
//        ${ApiUtils.Field.companyName}
//        ${ApiUtils.Field.additionName}
//        ${ApiUtils.Field.vatNumber}
//        ${ApiUtils.Field.optional1}
//        ${ApiUtils.Field.optional2}
//        ${ApiUtils.Field.autoCloseBill}
//        ${ApiUtils.Field.advertisingText}
//        ${ApiUtils.Field.country}
//        ${ApiUtils.Field.language}
//        printer {
//            ${ApiUtils.Field.autoPrintBills}
//            ${ApiUtils.Field.notPrintRFIDBills}
//            ${ApiUtils.Field.printBillFromAmount}
//            ${ApiUtils.Field.__typename}
//        }
//        ${ApiUtils.Field.loginMode}
//        ${ApiUtils.Field.loyaltyProdItemId}
//        ${ApiUtils.Field.loyaltyProdItemIdOp2}
//        ${ApiUtils.Field.loyaltyProdItemIdOp3}
//        ${ApiUtils.Field.loyaltyProdItemIdOp4}
//        ${ApiUtils.Field.loyaltyProdItemIdOp5}
//        ${ApiUtils.Field.employeeLoyaltyProductId}
//        ${ApiUtils.Field.smsNotificationPhoneNumbers}
//        ${ApiUtils.Field.__typename}
//    }
//    ${ApiUtils.Field.__typename}
//}